import WalletTypeButton from './WalletTypeButton';

export default WalletTypeButton;
